import { render, staticRenderFns } from "./IllegalReleaseForm.vue?vue&type=template&id=4e1cd099&scoped=true&"
import script from "./IllegalReleaseForm.vue?vue&type=script&lang=js&"
export * from "./IllegalReleaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1cd099",
  null
  
)

export default component.exports